"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "marciana": {
    "5515d852": [{
      "hkey": "b595c25d",
      "slug": "zanca-sant-andrea",
      "name": "Zanca-Sant'Andrea",
      "primary": true,
      "skipSearch": false
    }],
    "sant-andrea": [{
      "hkey": "b595c25d",
      "slug": "zanca-sant-andrea",
      "name": "Zanca-Sant'Andrea",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "marciana"
    }],
    "18698286": [{
      "hkey": "b595c25d",
      "slug": "zanca-sant-andrea",
      "name": "Zanca-Sant'Andrea",
      "primary": true,
      "skipSearch": false
    }],
    "zanca": [{
      "hkey": "b595c25d",
      "slug": "zanca-sant-andrea",
      "name": "Zanca-Sant'Andrea",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;